import { render, staticRenderFns } from "./UploaderWrapper.vue?vue&type=template&id=df79ea34&"
import script from "./UploaderWrapper.vue?vue&type=script&lang=js&"
export * from "./UploaderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports